import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import ClassesoptionsService from "./ClassesoptionsService";
import ClassesService from "../classe/ClassesService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";

import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import StatutsService from "../statuts/StatutsService";

export default function ClassesOptionsIndex() {
    const activeLink = "CLASSES OPTIONS"

    const token = useSelector(state => state.auth.token)
    const [classesoptions, setClassesoptions] = useState([])
    const [classes, setClasses] = useState([]);

    const [statuts, setStatuts] = useState([]);

    const [errors, setErrors] = useState({});

    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);


    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //declaration des variables pour le form d'enregistrement
    const [addFormData, setAddFormData] = useState({
        libelleClasseOption: '',
        descriptionClasseOption: '',
        classeId: '',
        capaciteClasseOption: '',
        montantClasseOption: '',
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        libelleClasseOption: '',
        descriptionClasseOption: '',
        classeId: '',
        statutId: '',
        capaciteClasseOption: '',
        montantClasseOption: '',
        id: ''
    });

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        libelleClasseOption: Joi.string().min(2).max(200).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Libelle"),

        descriptionClasseOption: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        classeId: Joi.number().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Classe"),

        capaciteClasseOption: Joi.number().integer().empty('').options({
            language: {
                any: { number: 'vous devez renseignez un nombre' },
                number: { integer: 'Doit être un nombre entier' },
            },
        }).label("Capacité"),

        montantClasseOption: Joi.number().integer().empty('').options({
            language: {
                any: { number: 'vous devez renseignez un nombre' },
                number: { integer: 'Doit être un nombre entier' },
            },
        }).label("Montant Scolarité"),
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        libelleClasseOption: Joi.string().min(2).max(200).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Libelle"),

        descriptionClasseOption: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        id: Joi.number().min(1).empty('').options({
            language: {
                number: { min: "minimum 1" },
            },
        }).label("Id"),

        statutId: Joi.number().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Statut"),

        classeId: Joi.number().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Classe"),

        capaciteClasseOption: Joi.number().integer().empty('').options({
            language: {
                any: { number: 'vous devez renseignez un nombre' },
                number: { integer: 'Doit être un nombre entier' },
            },
        }).label("Capacité"),

        montantClasseOption: Joi.number().integer().empty('').options({
            language: {
                any: { number: 'vous devez renseignez un nombre' },
                number: { integer: 'Doit être un nombre entier' },
            },
        }).label("Montant Scolarité"),
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleClasseOption: '',
            descriptionClasseOption: '',
            classeId: '',
            capaciteClasseOption: '',
            montantClasseOption: '',
        });
    };

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData((prevData) => ({
            ...prevData,
            [name]: value
        }))
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //get liste classes
    const fetchClasses = async () => {
        await ClassesService.index(token)
            .then((res) => {
                //console.log(res.data.data)
                setClasses(res.data.data.classes);
            })
            .catch((error) => {
                console.log(error);
            });
    };


    //get liste classesoptions
    const fetchClassesoptions = async () => {
        await ClassesoptionsService.index(token).then((res) => {
            //console.log(res.data.data)
            setClassesoptions(res.data.data.classesoptions)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                ClassesoptionsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchClassesoptions()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //Enregistrer une classe options
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await ClassesoptionsService.store(addFormData, token).then((response) => {
                //console.log(response.data.data)
                //Fermer le modal
                setIsVisible(false)
                if (response.data.status === 200) {
                    //Vider les champs du formulaire
                    clearForm()
                    //Actualiser la liste
                    fetchClassesoptions()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                //affichage des erreurs sur le formulaire
                //setValidationError(error.message)
            });
        }

    }

    ///Content du modal d'ajout de classe
    const addModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleSubmit}>
            <div className="row">
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Classe <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="classeId" id="bs-validation-classeId" value={addFormData.classeId} onChange={handleChange} required>
                        <option value="" selected disabled>Sélectionnez une valeur</option>
                        {classes.length > 0 && classes.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleClasse}</option>
                        ))}
                    </Form.Select>

                    {errors.classeId && (
                        <div className="alert alert-danger">
                            {errors.classeId}
                        </div>
                    )}

                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleClasseOption"
                        type="text"
                        value={addFormData.libelleClasseOption}
                        onChange={handleChange}
                        placeholder=""
                        required={true}
                        name="libelleClasseOption"
                    />

                    {errors.libelleClasseOption && (
                        <div className="alert alert-danger">
                            {errors.libelleClasseOption}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-capaciteClasseOption"
                    >
                        Capacité <i className="text-danger"></i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-capaciteClasseOption"
                        type="number"
                        value={addFormData.capaciteClasseOption}
                        onChange={handleChange}
                        placeholder=""
                        name="capaciteClasseOption"
                    />

                    {errors.capaciteClasseOption && (
                        <div className="alert alert-danger">
                            {errors.capaciteClasseOption}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-montantClasseOption"
                    >
                        Montant Scolarité<i className="text-danger"></i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-montantClasseOption"
                        type="number"
                        value={addFormData.montantClasseOption}
                        onChange={handleChange}
                        placeholder=""
                        name="montantClasseOption"
                    />

                    {errors.montantClasseOption && (
                        <div className="alert alert-danger">
                            {errors.montantClasseOption}
                        </div>
                    )}
                </div>

            </div>

            <div className=" mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionClasseOption" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionClasseOption"
                    onChange={handleChange}
                    name="descriptionClasseOption"
                    rows="3"
                    value={addFormData.descriptionClasseOption}
                ></textarea>

                {errors.descriptionClasseOption && (
                    <div className="alert alert-danger">
                        {errors.descriptionClasseOption}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await ClassesoptionsService.show(id, token).then((response) => {
            const data = response.data.data;
            //console.log("montantClasseOption:", data.montantClasseOption);
            setEditFormData({
                libelleClasseOption: data.libelleClasseOption,
                descriptionClasseOption: data.descriptionClasseOption,
                capaciteClasseOption: data.capaciteClasseOption,
                montantClasseOption: data.montantClasseOption ?? 0,
                statutId: data.statuts.id,
                classeId: data.classes.id,
                id: data.id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //update fonction
    const handleUpdate = async (event) => {
        event.preventDefault()
        //console.log("okay")
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await ClassesoptionsService.update(editFormData, token).then((response) => {
                //Fermer le modal
                setEditModal(false)

                if (response.data.status !== 200) {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });

                } else {
                    fetchClassesoptions()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                //Fermer le modal
                setEditModal(false)

                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
            });

        }
    };


    ///Content du modal d'edition de matière
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Classe <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="classeId" id="bs-validation-classeId" value={editFormData.classeId} onChange={handleEditChange} required>
                        {classes.length > 0 && classes.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleClasse}</option>
                        ))}
                    </Form.Select>

                    {errors.classeId && (
                        <div className="alert alert-danger">
                            {errors.classeId}
                        </div>
                    )}

                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleClasseOption"
                        type="text"
                        value={editFormData.libelleClasseOption}
                        onChange={handleEditChange}
                        placeholder=""
                        required={true}
                        name="libelleClasseOption"
                    />

                    {errors.libelleClasseOption && (
                        <div className="alert alert-danger">
                            {errors.libelleClasseOption}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-capaciteClasseOption"
                    >
                        Capacité <i className="text-danger"></i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-capaciteClasseOption"
                        type="number"
                        value={editFormData.capaciteClasseOption}
                        onChange={handleEditChange}
                        placeholder=""
                        name="capaciteClasseOption"
                    />

                    {errors.capaciteClasseOption && (
                        <div className="alert alert-danger">
                            {errors.capaciteClasseOption}
                        </div>
                    )}
                </div>

                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-montantClasseOption"
                    >
                        Montant Scolarité<i className="text-danger"></i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-montantClasseOption"
                        type="number"
                        value={editFormData.montantClasseOption}
                        onChange={handleEditChange}
                        placeholder=""
                        name="montantClasseOption"
                    />

                    {errors.montantClasseOption && (
                        <div className="alert alert-danger">
                            {errors.montantClasseOption}
                        </div>
                    )}
                </div>

                <div className=" col-md-12 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Statuts <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="statutId" id="bs-validation-statutId" value={editFormData.statutId} onChange={handleEditChange} required>
                        {statuts.length > 0 && statuts.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleStatut}</option>
                        ))}
                    </Form.Select>

                    {errors.statutId && (
                        <div className="alert alert-danger">
                            {errors.statutId}
                        </div>
                    )}

                </div>
            </div>

            <div className=" mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionClasseOption" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionClasseOption"
                    onChange={handleEditChange}
                    name="descriptionClasseOption"
                    rows="3"
                    value={editFormData.descriptionClasseOption}
                ></textarea>

                {errors.descriptionClasseOption && (
                    <div className="alert alert-danger">
                        {errors.descriptionClasseOption}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    //get liste statuts
    const fetchStatuts = async () => {
        await StatutsService.index(token).then((res) => {
            setStatuts(res.data.data.statuts)
        }).catch(error => {
            console.log(error)
        })
    }

    //redirection sur la page edit sans afficher les id dans l'url
  const  handleClickemploidutemps = (param) => {
   // console.log("ok",param)
    navigate(myroutes.emploidutemps_classes, { state: { id: param } });
   };


    useEffect(() => {
        fetchClassesoptions();
        fetchClasses();
        fetchStatuts()
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-3 mt-2">
                    <h5 className="card-header">Liste des classes options
                        &nbsp; &nbsp; &nbsp;  <Button variant="primary" onClick={() => setIsVisible(true)}>
                            <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une classe option
                        </Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Classe </th>
                                    <th className="cell text-white">Classe Option</th>
                                    <th className="cell text-white">Capacité</th>
                                    <th className="cell text-white">Montant scolarité</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Statuts</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {classesoptions.length > 0 && classesoptions.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.classes?.libelleClasse}
                                        </td>
                                        <td className="cell">{item.libelleClasseOption}
                                        </td>
                                        <td className="cell">{item.capaciteClasseOption}
                                        </td>
                                        <td className="cell">{item.montantClasseOption}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.descriptionClasseOption}</span></td>
                                        <td className="cell">
                                            <span className={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell d-flex">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>&nbsp; &nbsp;
                                                <Button
                                            className="btn btn-sm"
                                            variant="secondary"
                                            onClick={() => handleClickemploidutemps(item.id)}
                                            title="consulter emploi du temps"
                                        >
                                            <i className="pi pi-bookmark"></i>
                                        </Button>
                                         </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>

            {/* Modal Ajout des classesoptions*/}
            <CustomAddModal
                modalTitle="Enregistrement classe option"
                modalContent={addModalContent}
                visible={isVisible}
                close={() => setIsVisible(false)}
            />

            {/**End Modal Ajout des classesoptions*/}

            {/* Modal Edition des classesoptions*/}
            <CustomEditModal
                modalTitle="Modification classe option"
                modalContent={editModalContent}
                visible={editModal}
                close={() => setEditModal(false)}
            />

            {/**End Modal Edition des classesoptions*/}

        </Layout>
    )
}